import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isProductBundle as isProductBundleUtil } from 'commerce-products-lib/utils/subject';
import { Button } from 'foundations-components/transitional/components/Button';
import { PRODUCT_BUILDER_IFRAME_GATE } from 'products-ui-components/constants/permissions';
import { useCallback } from 'react';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useProductData } from '../../contexts/ProductDataContext';
import { useProductEditModal } from '../../contexts/ProductEditModalContext';
import { useProductId } from '../../contexts/ProductIdContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightEditButton = () => {
  const productId = useProductId();
  const {
    product
  } = useProductData();
  const {
    hasScope,
    hasGate
  } = usePermissionsContext();
  const {
    setIsEditModalOpen
  } = useProductEditModal();
  const hasProductEditScope = hasScope('inbounddb-product-library-write');
  const isUngatedForProductCreatorIFrame = hasGate(PRODUCT_BUILDER_IFRAME_GATE);
  const handleClick = useCallback(() => {
    setIsEditModalOpen(true);
  }, [setIsEditModalOpen]);
  if (!productId || !hasProductEditScope) {
    return null;
  }
  const isProductBundle = !!product && isProductBundleUtil(product);
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    onClick: isUngatedForProductCreatorIFrame || isProductBundle ? handleClick : undefined,
    href: isUngatedForProductCreatorIFrame || isProductBundle ? undefined : `/products/${PortalIdParser.get()}/edit/${productId}`,
    "data-test-id": "edit-product-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.edit"
    })
  });
};